import React, { FC, memo } from 'react'

import { LoginHeader } from '@/components/LoginHeader'
import { DescriptionQr } from '@/components/QrCode/DescriptionQr'
import { QrCode } from '@/components/QrCode/QrCode'
import { titleData } from '@/constants/login'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { SelfServiceSessionProps } from '@/types/componentsPropsTypes'

import { RegisterQrContainer, SessionContainer } from './styles'
import { QrWrapperMobileBg } from '../styles'

const SelfServiceSessionRow: FC<SelfServiceSessionProps> = ({
  code,
  qrUrl,
  qrCodeUrl,
  remainingTime,
}) => {
  const { t } = useCommonTranslation()

  return (
    <SessionContainer>
      <LoginHeader
        showLogo={false}
        title={t(titleData.created_selfService.title)}
        description={t(titleData.created_selfService.description)}
      />
      <RegisterQrContainer>
        <QrWrapperMobileBg>
          {qrCodeUrl && <QrCode qrPath={qrCodeUrl} />}
        </QrWrapperMobileBg>
        <DescriptionQr
          link={qrUrl}
          code={code}
          mobileStyle={true}
          remainingTime={remainingTime}
        />
      </RegisterQrContainer>
    </SessionContainer>
  )
}

export const SelfServiceSession = memo(SelfServiceSessionRow)
